import SelectManual from "./SelectManual";

export default SelectManual;
